import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import AdminApp from "./AdminApp";
import MarketingApp from "./MarketingApp";
import { prepareManagedAuth } from "./auth";
import "./styles.css";

const isMarketingPreview = window.location.pathname.startsWith("/preview");
if(!isMarketingPreview) await prepareManagedAuth();

const isAdminHost = window.location.hostname.startsWith("admin-staging.") || window.location.hostname.startsWith("admin.");
const Root = isMarketingPreview ? MarketingApp : isAdminHost || window.location.pathname.startsWith("/admin") ? AdminApp : App;
document.title = isMarketingPreview ? "MIL IAgentes · Recepción inteligente" : "MIL IAgentes · Panel";
createRoot(document.getElementById("root")!).render(
  <StrictMode><Root /></StrictMode>,
);
